/* @flow */

import {createAction} from 'redux-act';

import type {FacebookReportDataRequestedAction} from '../types';

/*
 * Action creators
 */
export const requestReportData: (
    payload: $PropertyType<FacebookReportDataRequestedAction, 'payload'>
) => FacebookReportDataRequestedAction = createAction('FACEBOOK_REPORT_DATA_REQUESTED');
export const updateReportChartData = createAction('FACEBOOK_REPORT_CHART_DATA_UPDATED');
export const updateReportMaps = createAction('FACEBOOK_REPORT_MAPS_UPDATED');
export const failReportChartData = createAction('FACEBOOK_REPORT_CHART_DATA_FAILED');
